// Takes the Wordpress formatted JSON style string and turns it into a JS object that can be used for a JSX element's style attribute

export default function formatStyles(stylesJsonString) {
	var stylesObj = {};

	function printProperty(property, key, nestedLevel) {
		if (nestedLevel === 1) return;
		if (property) {
			return `${property}${key.charAt(0).toUpperCase()}${key.slice(1)}`;
		} else {
			return key;
		}
	}

  function cleanValue(value) {
    value = value.replace(/\|/g, '-');
    value = value.replace(/^var:(.*)$/, 'var(--$1)');
    return value;
  }

	function getStylesStrings(obj, nestedLevel, property = null) {
		nestedLevel++;
		Object.keys(obj).forEach((key) => {
			if (obj[key].constructor.name === 'Object') {
				getStylesStrings(obj[key], nestedLevel, printProperty(property, key, nestedLevel));
			} else {
				stylesObj[`${printProperty(property, key, nestedLevel)}`] = cleanValue(obj[key]);
			}
		});
	}

	if (stylesJsonString) {
		const json = JSON.parse(stylesJsonString);
		getStylesStrings(json, 0);
	}
	return stylesObj;
}
